import { useSelector } from "react-redux";
import GraphSkeletonForTrendsMob from "../../../helpers/components/GraphSkeletonForTrendsMob";
import { Box } from "@mui/system";
import CVRChartWrap from "./CVRContent/CVRChartWrap";

const CVR = () => {
  const { loadingTrendsMobData } = useSelector((state: any) => state.trends);
  return (
    <>
      <Box sx={{ px: 2 }}>
        {loadingTrendsMobData ? (
          Array.from({ length: 2 }).map((_, index) => (
            <GraphSkeletonForTrendsMob key={index} />
          ))
        ) : (
          <CVRChartWrap />
        )}
      </Box>
    </>
  );
};

export default CVR;
